import * as globalConfigurationAction from './action';
const initialState = {
    createGlobalConfigSuccess: [],
    createGlobalConfigFailure: [],
    globalConfigData: [],
    globalConfigDataFailure: [],
    aggregatePredefinedSuccess: [],
    aggregatePredefinedFailure: [],
    variablePredefinedSuccess: [],
    variablePredefinedFailure: [],
    masterDataList: [],
    masterDataListFailure: [],
    createMasterDataSuccess: [],
    createMasterDataFailure: [],
    xbrlDownloadTemplateSuccess: [],
    xbrlDownloadTemplateFailure: [],
    uploadXbrlTemplate: [],
    uploadXbrlTemplateFailure: [],
    mappingStatistics: [],
    mappingStatisticsFailure: [],
    masterkeysByApiKeySuccess: [],
    masterkeysByApiKeyFailure: [],
    downloadBulkMasterKeyRequestTemplateSuccess: {},
    downloadBulkMasterKeyRequestTemplateFailure: {},
    submitBulkMasterKeyRequestSuccess: {},
    submitBulkMasterKeyRequestFailure: {},
    apiAccessesInfoData: [],
    accessTypes: [],
    apiAccessesSubmitData: null
}
const globalConfigurationReducer = (state = initialState, action) => {
    switch (action.type) {
        case globalConfigurationAction.SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG_SUCCESS:
            return state = {
                ...state,
                createGlobalConfigSuccess: action.data
            }
        case globalConfigurationAction.SAVE_CREDIT_WORTHINESS_GLOBAL_CONFIG_FAILURE:
            return state = {
                ...state,
                createGlobalConfigFailure: action.data
            }
        case globalConfigurationAction.FETCH_GLOBAL_CONFIGURATION_SUCCESS:
            return state = {
                ...state,
                globalConfigData: action.data
            }
        case globalConfigurationAction.FETCH_GLOBAL_CONFIGURATION_FAILURE:
            return state = {
                ...state,
                globalConfigDataFailure: action.data
            }
        case globalConfigurationAction.FETCH_AGGREGATE_PREDEIFENED_FIELD_SUCCESS:
            return state = {
                ...state,
                aggregatePredefinedSuccess: action.data
            }
        case globalConfigurationAction.FETCH_AGGREGATE_PREDEIFENED_FIELD_FAILURE:
            return state = {
                ...state,
                aggregatePredefinedFailure: action.data
            }
        case globalConfigurationAction.FETCH_VARIABLE_PREDEIFENED_FIELD_SUCCESS:
            return state = {
                ...state,
                variablePredefinedSuccess: action.data
            }
        case globalConfigurationAction.FETCH_VARIABLE_PREDEIFENED_FIELD_FAILURE:
            return state = {
                ...state,
                variablePredefinedFailure: action.data
            }
        case globalConfigurationAction.GET_MASTER_DATA_KEY_LIST_SUCCESS:
            return state = {
                ...state,
                masterDataList: action.data
            }
        case globalConfigurationAction.GET_MASTER_DATA_KEY_LIST_FAILURE:
            return state = {
                ...state,
                masterDataListFailure: action.data
            }
        case globalConfigurationAction.CREATE_MASTER_DATA_KEY_SUCCESS:
            return state = {
                ...state,
                createMasterDataSuccess: action.data
            }
        case globalConfigurationAction.CREATE_MASTER_DATA_KEY_FAILURE:
            return state = {
                ...state,
                createMasterDataFailure: action.data
            }
        case globalConfigurationAction.DOWNLOAD_XBRL_MASTER_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                xbrlDownloadTemplateSuccess: action.data
            }
        case globalConfigurationAction.DOWNLOAD_XBRL_MASTER_TEMPLATE_FAILURE:
            return state = {
                ...state,
                xbrlDownloadTemplateFailure: action.data
            }
        case globalConfigurationAction.UPLOAD_XBRL_MASTER_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                uploadXbrlTemplate: action.data
            }
        case globalConfigurationAction.UPLOAD_XBRL_MASTER_TEMPLATE_FAILURE:
            return state = {
                ...state,
                uploadXbrlTemplateFailure: action.data
            }
        case globalConfigurationAction.XBRL_MAPPING_STATISTICS_SUCCESS:
            return state = {
                ...state,
                mappingStatistics: action.data
            }
        case globalConfigurationAction.XBRL_MAPPING_STATISTICS_FAILURE:
            return state = {
                ...state,
                mappingStatisticsFailure: action.data
            }
        case globalConfigurationAction.FETCH_MASTERKEY_BY_APIKEY_SUCCESS:
            return state = {
                ...state,
                masterkeysByApiKeySuccess: action.data
            }
        case globalConfigurationAction.FETCH_MASTERKEY_BY_APIKEY_FAILURE:
            return state = {
                ...state,
                masterkeysByApiKeyFailure: action.data
            }
        case globalConfigurationAction.DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE_SUCCESS:
            return state = {
                ...state,
                downloadBulkMasterKeyRequestTemplateSuccess: action.data
            }
        case globalConfigurationAction.DOWNLOAD_BULK_MASTER_KEY_REQUEST_TEMPLATE_FAILURE:
            return state = {
                ...state,
                downloadBulkMasterKeyRequestTemplateFailure: action.error
            }
        case globalConfigurationAction.SUBMIT_BULK_MASTER_KEY_REQUEST_SUCCESS:
            return state = {
                ...state,
                submitBulkMasterKeyRequestSuccess: action.data
            }
        case globalConfigurationAction.SUBMIT_BULK_MASTER_KEY_REQUEST_FAILURE:
            return state = {
                ...state,
                submitBulkMasterKeyRequestFailure: action.error
            }
        case globalConfigurationAction.API_ACCESSES_INFO_SUCCESS:
            return state = {
                ...state,
                apiAccessesInfoData: action.data
            };
        case globalConfigurationAction.API_ACCESSES_INFO_FAILURE:
            return state = {
                ...state,
                apiAccessesInfoData: action
            };
        case globalConfigurationAction.API_ACCESS_TYPES_SUCCESS:
            return state = {
                ...state,
                accessTypes: action.data
            };
        case globalConfigurationAction.API_ACCESS_TYPES_FAILURE:
            return state = {
                ...state,
                accessTypes: action
            };
        case globalConfigurationAction.API_ACCESSES_SUBMIT_SUCCESS:
            return state = {
                ...state,
                apiAccessesSubmitData: action.data
            };
        case globalConfigurationAction.API_ACCESSES_SUBMIT_FAILURE:
            return state = {
                ...state,
                apiAccessesSubmitData: action
            };
        default: return state
    }
}

export default globalConfigurationReducer; 